import * as React from "react";
import { FC } from "react";
import { PopupBody, PopupHeader } from "./Popup";
import { useAppContext } from "../Contexts/AppContext";
import { Checkbox } from "../Elements/Checkbox";
import { config } from "../Map/config";
import { CloseButton } from "../Elements/CloseButton";
import { getMap } from "../Forms/DrawingForm";
import "./LayersMenu.scss";

export const LayersMenu: FC = () => {
    const { isMobile, toggleLayersMenuVisible, setLayerToToggle } = useAppContext();

    const isVisible = (layerId: string): boolean => {
        const map = getMap();
        return map
            ? !!map
                  .getLayers()
                  .getArray()
                  .find((layer) => layer.get("id") === layerId)
            : false;
    };

    return (
        <div className="shadow" id="layers-popup">
            {isMobile ? (
                <PopupHeader isMobile={isMobile}>
                    <CloseButton onClose={toggleLayersMenuVisible}></CloseButton>
                </PopupHeader>
            ) : (
                <div className="triangle-left"></div>
            )}
            <PopupBody isMobile={isMobile}>
                {config.layers.map((layer) => {
                    return (
                        <div key={"layer-" + layer.id}>
                            <Checkbox
                                label={layer.title}
                                subTitle={"© " + layer.copyright}
                                defaultChecked={isVisible(layer.id)}
                                onChange={(e) => setLayerToToggle({ visible: e, layerId: layer.id })}
                            ></Checkbox>
                        </div>
                    );
                })}
            </PopupBody>
        </div>
    );
};
